import variables from "@/_styles/variables.module.scss"

import { IProvider } from "./IProvider"

import { IDriver } from "@/types/IDriver"


export interface IOrderAuthorities {
  orderId: number,
  orderNumber: string,
  customerName: string
}

export interface IAuthorities {
  id: number
  number: string
  date: Date
  orderAuthorities: IOrderAuthorities
  driver: IDriver
  providerId: number
  provider: IProvider
  issuedName?: string
  isRegisteredIn1C: boolean
}

export interface IAuthoritiesCreate {
  number: string
  date: Date
  orderId: number
  driverId: number
  newDrivers: IDriver[]
  providerId: number
}

export interface IAuthoritiesUpdate extends IAuthoritiesCreate {
  id: number
}

export interface IAuthorityLogs {
  id: number
  authorityNumber: string
  dateTime: Date
  status: number
  statusText: string
  storageKey: string
}

export interface IAuthorityRegisterLogs {
  id: number
  authorityNumber: string
  startDateTime: Date
  endDateTime: Date
  status: number
  statusText: string
  storageKey: string
  requestParams: string
  errorText?: string
}


export interface IAuthorityRegisterRequest {
  Number: string
  Date: Date
  DriverFullName: string
  Inn: string
  Kpp: string
}

export const LogStatusColors: Record<number, string> = {
  0: variables.statusGreenColor,  // Данные доступны
  1: variables.statusRedColor,    // Данные с ошибкой
  2: variables.statusOrangeColor,  // Данные не найдены
  3: variables.textGrayColor  // Получено недостаточно данных
}

export const AUTHORITIES_KEY = "AUTHORITIES_KEY"
export const AUTHORITY_LOGS_KEY = "AUTHORITY_LOGS_KEY"
export const AUTHORITY_REGISTER_LOGS_KEY = "AUTHORITY_REGISTER_LOGS_KEY"